module.exports = __webpack_public_path__ + "img/1.ddcdf55e.png";